import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';

import LandingPageStyles from '../../styles/LandingPageStyles';

export const SubpageFooterContainer = styled.div`
    margin-top: 57px;

    .footer-nav {
        align-items: center;
        display: flex;
        justify-content: space-between;
        max-width: 100%;
    }
    
    .nav-text {
        color: ${colors.grayscaleCoolGray11};
        font-family: 'acumin-pro', sans-serif;
        font-size: 18px;
        font-weight: 500;
        line-height: 1.28;
        letter-spacing: normal;
        position: absolute;
        top: 32%;
        transform: translateY(-50%);
    }
    .footer-left {
        position: relative;
        width: 50%;

        .nav-text {
            left: 45px;
        }
        .circle-arrow {
            transform: rotate(180deg);
        }
        .hover-state {
            display: none;
        }
        .standard-state {
            display: inline;
        }
        svg {
            height: 33px;
            width: 33px;
        }
        a:hover {
            .hover-state {
                display: inline;
            }
            .standard-state {
                display: none;
            }
        }
    }
    .footer-right {
        position: relative;
        text-align: right;
        width: 50%;

        .nav-text {
            right: 45px;
        }
        .hover-state {
            display: none;
        }
        .standard-state {
            display: inline;
        }
        svg {
            height: 33px;
            width: 33px;
        }
        a:hover {
            .hover-state {
                display: inline;
            }
            .standard-state {
                display: none;
            }
        }
    }
    .circle-arrow {
        display: inline-block;
        margin-bottom: 12px;
        max-width: 64px;
    }

    .footer-container {
        color: ${colors.grayscaleCoolGray06};
        position: relative;

        a {
            color: ${colors.grayscaleCoolGray06};

            &:hover {
                color: ${colors.grayscaleCoolGray08};
            }
        }
    }

    /* - DESKTOP VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        .footer-nav {
            margin: 0 1.58%;
        }
    }

    /* - TABLET VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.tablet}){
        .footer-nav {
            margin: 0 4%;
        }
    }

    /* - MOBILE VIEW - */
    @media screen and (${LandingPageStyles.viewBreakpoints.mobile}){
        margin-top: 0;

        .footer-nav {
            margin: auto;
            width: 80%;
        }

        .footer-right,
        .footer-left {
            a:hover {
                .hover-state {
                    display: none;
                }
                .standard-state {
                    display: inline-block;
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/SubpageFooter/SubpageFooterStyles.js